import * as React from 'react';
import * as AvatarPrimitive from '@radix-ui/react-avatar';
import { cn } from '@/shared/lib/cn';

export const Avatar = React.forwardRef<
  React.ElementRef<typeof AvatarPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Root>
>(({ className, ...props }, ref) => (
  <AvatarPrimitive.Root
    ref={ref}
    className={cn(
      'relative flex h-10 w-10 shrink-0 overflow-hidden rounded-md select-none',
      className,
    )}
    {...props}
  />
));
Avatar.displayName = 'Avatar';

export const AvatarImage = React.forwardRef<
  React.ElementRef<typeof AvatarPrimitive.Image>,
  React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Image>
>(({ className, ...props }, ref) => (
  <AvatarPrimitive.Image
    ref={ref}
    className={cn('aspect-square h-full w-full object-cover', className)}
    {...props}
  />
));
AvatarImage.displayName = 'AvatarImage';

export const AvatarFallback = React.forwardRef<
  React.ElementRef<typeof AvatarPrimitive.Fallback>,
  React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Fallback>
>(({ className, ...props }, ref) => (
  <AvatarPrimitive.Fallback
    ref={ref}
    className={cn(
      'flex h-full w-full items-center justify-center text-xs font-bold text-white',
      className,
    )}
    {...props}
  />
));
AvatarFallback.displayName = 'AvatarFallback';

/** Paleta determinística para colorear avatares por id. */
const GRADIENTS = [
  'bg-gradient-to-br from-indigo-400 to-indigo-700',
  'bg-gradient-to-br from-blue-400 to-blue-800',
  'bg-gradient-to-br from-purple-400 to-purple-700',
  'bg-gradient-to-br from-amber-400 to-amber-700',
  'bg-gradient-to-br from-pink-400 to-pink-700',
  'bg-gradient-to-br from-teal-400 to-teal-700',
  'bg-gradient-to-br from-red-400 to-red-700',
] as const;

export function avatarGradient(seed: string): string {
  // Hash determinístico simple por código de carácter.
  let acc = 0;
  for (let i = 0; i < seed.length; i++) acc = (acc * 31 + seed.charCodeAt(i)) | 0;
  const idx = Math.abs(acc) % GRADIENTS.length;
  return GRADIENTS[idx] ?? GRADIENTS[0]!;
}
